/**
 * 裝置方向偵測工具
 * 用於偵測使用者是否將裝置轉為橫向，並顯示提示訊息
 */

class OrientationDetector {
  constructor() {
    this.callbacks = [];
    this.isLandscape = false;
    this.init();
  }

  init() {
    // 初始檢查方向
    this.checkOrientation();
    
    // 監聽方向改變事件
    window.addEventListener('orientationchange', () => {
      // 延遲檢查，確保方向已完全改變
      setTimeout(() => {
        this.checkOrientation();
      }, 100);
    });

    // 監聽視窗大小改變（作為備用方案）
    window.addEventListener('resize', () => {
      this.checkOrientation();
    });
  }

  checkOrientation() {
    const isCurrentlyLandscape = this.getIsLandscape();
    console.log('Checking orientation...', isCurrentlyLandscape);
    console.log('Orientation check:', isCurrentlyLandscape ? 'Landscape' : 'Portrait');
    if (isCurrentlyLandscape !== this.isLandscape) {
      this.isLandscape = isCurrentlyLandscape;
      this.notifyCallbacks(this.isLandscape);
    }
  }

  getIsLandscape() {
    // 檢查多種方式來確定是否為橫向
    
    // 方法1: 使用 screen.orientation (現代瀏覽器)
    // if (screen.orientation) {
    //   return screen.orientation.angle === 90 || screen.orientation.angle === -90 || screen.orientation.angle === 270;
    // }
    console.log('screen.orientation:', screen.orientation);
    // // 方法2: 使用 window.orientation (較舊的方式)
    // if (typeof window.orientation !== 'undefined') {
    //   return Math.abs(window.orientation) === 90;
    // }
    
    // 方法3: 比較寬度和高度 (備用方案)
    return window.innerWidth > window.innerHeight;
  }

  // 註冊回調函數
  onOrientationChange(callback) {
    this.callbacks.push(callback);
    
    // 返回取消註冊的函數
    return () => {
      this.callbacks = this.callbacks.filter(cb => cb !== callback);
    };
  }

  // 通知所有回調函數
  notifyCallbacks(isLandscape) {
    this.callbacks.forEach(callback => {
      try {
        callback(isLandscape);
      } catch (error) {
        console.error('OrientationDetector callback error:', error);
      }
    });
  }

  // 手動檢查當前方向
  getCurrentOrientation() {
    return this.getIsLandscape();
  }

  // 銷毀監聽器
  destroy() {
    window.removeEventListener('orientationchange', this.checkOrientation);
    window.removeEventListener('resize', this.checkOrientation);
    this.callbacks = [];
  }
}

// 建立單例實例
const orientationDetector = new OrientationDetector();

export default orientationDetector;